"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../Icon/Icon"));

var _MotionFlex = _interopRequireDefault(require("../../motionComponents/MotionFlex/MotionFlex"));

/* eslint-disable no-nested-ternary */

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable react/jsx-props-no-spreading */
var IconWrapper = function IconWrapper(_ref) {
  var noIconRotate = _ref.noIconRotate,
      disableClearButton = _ref.disableClearButton,
      selectedOption = _ref.selectedOption,
      disabled = _ref.disabled,
      amountOfOptions = _ref.amountOfOptions,
      size = _ref.size,
      color = _ref.color,
      iconName = _ref.iconName,
      onClick = _ref.onClick,
      getExpandedState = _ref.getExpandedState;

  var getIconCursor = function getIconCursor() {
    if (disabled) {
      return "not_allowed";
    }

    if (disableClearButton) {
      return "auto";
    }

    return selectedOption.value ? "pointer" : "auto";
  };

  var iconVariants = {
    unActive: {
      transform: "rotate(0deg)",
      transition: {
        duration: 0.3,
        ease: "easeInOut"
      }
    },
    active: {
      transform: "rotate(180deg)",
      transition: {
        duration: 0.3,
        ease: "easeInOut"
      }
    }
  };

  var isClearButtonActive = function () {
    if (iconName) {
      return false;
    }

    return disabled || disableClearButton ? false : !!selectedOption.value;
  }();

  return /*#__PURE__*/_react["default"].createElement(_MotionFlex["default"], {
    variants: iconVariants,
    initial: "unActive",
    className: "dropdown_button_icon_wrapper",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    animate: function () {
      if (noIconRotate) {
        return "unActive";
      }

      if (disableClearButton) {
        return amountOfOptions === 0 ? "unActive" : getExpandedState() ? "active" : "unActive";
      }

      return amountOfOptions === 0 ? "unActive" : getExpandedState() && !selectedOption.value ? "active" : "unActive";
    }(),
    width: 20,
    height: 20,
    ml: 2,
    mr: 3
  }, /*#__PURE__*/_react["default"].createElement(_MotionFlex["default"], {
    className: "dropdown_button_icon_wrapper_inner",
    whileHover: {
      scale: selectedOption.value && !disabled && !disableClearButton ? 1.05 : 1
    },
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    tabIndex: isClearButtonActive ? 0 : 1,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        onClick();
      }
    },
    role: "button",
    "aria-hidden": !isClearButtonActive,
    "aria-label": function () {
      if (iconName) {
        return iconName;
      }

      return disabled || disableClearButton ? "Dropdown Arrow" : selectedOption.value ? "Clear" : "Dropdown Arrow";
    }()
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "dropdown_button_icon",
    style: {
      cursor: getIconCursor()
    },
    size: size,
    color: color,
    name: function () {
      if (iconName) {
        return iconName;
      }

      return disabled || disableClearButton ? "arrow_drop_down" : selectedOption.value ? "close" : "arrow_drop_down";
    }(),
    onClick: onClick
  })));
};

var _default = IconWrapper;
exports["default"] = _default;